.repeater {
  display: flex;
}

.repeater--row {
  flex-direction: row;
}

.repeater--row-reverse {
  flex-direction: row-reverse;
}

.repeater--column {
  flex-direction: column;
}

.repeater--column-reverse {
  flex-direction: column-reverse;
}

.repeater--gap-000 {
  gap: 0rem;
}

.repeater--gap-025 {
  gap: 0.25rem;
}

.repeater--gap-050 {
  gap: 0.5rem;
}

.repeater--gap-075 {
  gap: 0.75rem;
}

.repeater--gap-100 {
  gap: 1rem;
}

.repeater--gap-150 {
  gap: 1.5rem;
}

.repeater--gap-200 {
  gap: 2rem;
}
